import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=f16577d6"
import script from "./EventCalendar.vue?vue&type=script&lang=js"
export * from "./EventCalendar.vue?vue&type=script&lang=js"
import style0 from "./EventCalendar.vue?vue&type=style&index=0&id=f16577d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports